import { render, staticRenderFns } from "./Disclosure.vue?vue&type=template&id=3b1a05f1&scoped=true&"
import script from "./Disclosure.vue?vue&type=script&lang=ts&"
export * from "./Disclosure.vue?vue&type=script&lang=ts&"
import style0 from "./Disclosure.vue?vue&type=style&index=0&id=3b1a05f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1a05f1",
  null
  
)

export default component.exports